import type { QuizConfigUpdateRequest } from '@e-learning/core';
import { createQuizConfigApi } from '@e-learning/core';
import { useCallback } from 'react';
import { api } from '../../../../api/client';

const quizConfigApi = createQuizConfigApi(api);

export function useQuizConfig() {
  /**
   * Referências estáveis: `QuestionBankAdminTabs` usa `fetchQuizConfig` em um useEffect.
   * Sem useCallback, cada render do pai recria a função e re-dispara o GET em loop
   * (pior com erro 429: toast → setState → re-render → novo GET).
   */
  const fetchQuizConfig = useCallback(async () => {
    const cfg = await quizConfigApi.fetchQuizConfig();
    return { minScore: cfg.minScore, maxAttempts: cfg.maxAttempts };
  }, []);

  const updateQuizConfig = useCallback(async (body: QuizConfigUpdateRequest) => {
    await quizConfigApi.updateQuizConfig(body);
  }, []);

  return { fetchQuizConfig, updateQuizConfig };
}

